import apiClient from 'API/client';
import { API_ENDPOINTS } from 'API/endpoints';
import UI_MESSAGES from 'i18n/messages';

export const fetchCreateGetUser = async (id, userName) => {
  try {
    const data = {
      id,
      userName
    };

    const response = await apiClient.post(API_ENDPOINTS.USER.CREATE_OR_GET, data);

    if (response.status !== 200) {
      throw new Error(UI_MESSAGES.common.statusError('crear u obtener usuario', response.status));
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(UI_MESSAGES.logs.apiResponseError + ':', error.response.data);
    } else if (error.request) {
      console.error(UI_MESSAGES.logs.apiNetworkError + ':', error.request);
    } else {
      console.error(UI_MESSAGES.logs.apiGenericError + ':', error.message);
    }
    throw error;
  }
};

export default fetchCreateGetUser;
